import React from "react";
import RequireAuth from "../../requireAuth/RequireAuth";
import { Route } from "react-router-dom";
import { routes, userRoles } from "../../../constants";
import { GiftCardPaymentForm, OfferAndPackagesPaymentForm, ProfileSetup, SubscriptionPaymentForm, UpdateProfileSetup, WalletInfoPaymentForm } from "../../../component/pages/service-provider-admin"
import { ProfileSettings } from "../../../component/pages/staff";
import { AddPushNotificationPaymentForm, AddonPaymentForm } from "../../../component/pages/super-admin";
import { PayFinePaymentForm } from "../../../component/common/pay-fine-payment-form";
import StaffRenewalPaymentForm from "../../../component/pages/service-provider-admin/modules/staff/StaffRenewalPaymentForm";

const renderNoLayoutRoutes = () => {
  return (
    <>
      <Route path={routes.PROFILE_SETUP} element={<ProfileSetup />} />
      <Route element={<RequireAuth allowedRoles={[userRoles.SERVICE_PROVIDER_ADMIN]} />}>
        <Route path={routes.SUBSCRIPTION_PAYMENT} element={<SubscriptionPaymentForm />} />
        <Route path={routes.OFFER_AND_PACKAGES_PAYMENT} element={<OfferAndPackagesPaymentForm />} />
        <Route path={routes.WALLET_PAYMENT} element={<WalletInfoPaymentForm />} />
        <Route path={routes.ADDON_LOGIN_PAYMENT} element={<AddonPaymentForm />} />
        <Route path={routes.GIFT_CARD_PAYMENT} element={<GiftCardPaymentForm />} />
        <Route path={routes.FINE_PAYMENT} element={<PayFinePaymentForm />} />
        <Route path={routes.PUSH_NOTIFICATION_PAYMENT} element={<AddPushNotificationPaymentForm />} />
        <Route path={routes.STAFF_RENEWAL_PAYMENT} element={<StaffRenewalPaymentForm />} />
        <Route path={routes.UPDATE_PROFILE_SETUP} element={<UpdateProfileSetup />}/>

      </Route>

      <Route element={<RequireAuth allowedRoles={[userRoles.SERVICE_PROVIDER_ADMIN_ROLES.REGULAR_STAFF, userRoles.SERVICE_PROVIDER_ADMIN_ROLES.MEDICAL_STAFF, userRoles.SERVICE_PROVIDER_ADMIN_ROLES.DOCTOR]} />}>
        <Route path={routes.PROFILE_SETTINGS} element={<ProfileSettings />} />
      </Route>
    </>
  );
};

export default renderNoLayoutRoutes;
